import { useEffect, useState } from "react";
import api from "../services/api";

export default function TarifsPage() {
  const [tarif, setTarif] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/tarifs").then(res => setTarif(res.data[0]));
  }, []);

  const save = async () => {
    setSaving(true);
    await api.put(`/admin/tarifs/${tarif.id}`, tarif);
    setSaving(false);
    alert("Tarif mis à jour ✅");
  };

  if (!tarif) return <p style={{ padding: 20 }}>Chargement...</p>;

  return (
    <div style={{ padding: "1.5rem 0" }}>
      <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D", marginBottom: "1.5rem" }}>
        💰 Gestion des tarifs
      </h1>

      <div style={{ background: "#fff", borderRadius: 12, padding: 24, 
border: "0.5px solid #e5e5e5", maxWidth: 500 }}>
        {[
          ["prix_base",                  "Prix de base (CFA)"],
          ["prix_par_km",                "Prix par km (CFA)"],
          ["prix_minimum",               "Prix minimum (CFA)"],
          ["heure_pointe_multiplicateur","Multiplicateur heure de pointe"],
        ].map(([key, label]) => (
          <div key={key} style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, color: "#888", display: "block", 
marginBottom: 6 }}>{label}</label>
            <input
              type="number"
              value={tarif[key]}
              onChange={e => setTarif({ ...tarif, [key]: 
parseFloat(e.target.value) })}
              style={{
                width: "100%", padding: "10px 14px", borderRadius: 8,
                border: "0.5px solid #ddd", fontSize: 15, color: 
"#0B3C5D",
              }}
            />
          </div>
        ))}

        {/* Aperçu prix */}
        <div style={{ background: "#f7f7f7", borderRadius: 8, padding: 14, 
marginBottom: 16 }}>
          <div style={{ fontSize: 13, color: "#888", marginBottom: 8 
}}>Aperçu — trajet de 5 km</div>
          <div style={{ fontSize: 20, fontWeight: 600, color: "#0B3C5D" 
}}>
            {Math.round(tarif.prix_base + 5 * tarif.prix_par_km)} CFA
          </div>
          <div style={{ fontSize: 12, color: "#aaa", marginTop: 4 }}>
            Heure de pointe : {Math.round((tarif.prix_base + 5 * 
tarif.prix_par_km) * tarif.heure_pointe_multiplicateur)} CFA
          </div>
        </div>

        <button onClick={save} disabled={saving} style={{
          width: "100%", padding: "12px", borderRadius: 8, border: "none",
          background: "#0B3C5D", color: "#fff", fontSize: 14, cursor: 
"pointer",
          opacity: saving ? 0.7 : 1,
        }}>
          {saving ? "Sauvegarde..." : "💾 Sauvegarder"}
        </button>
      </div>
    </div>
  );
}
